import React from "react";
import { StyledGroupButton, StyledGroupButtonItem } from "./styles";
import { GroupButtonProps } from "./types";
import { Typography } from "../Typography";
import { theme } from "styles/theme";

export const GroupButton: React.FC<GroupButtonProps> = ({
  options,
  selectedValue,
  onChange,
}) => {
  return (
    <StyledGroupButton>
      {options.map((option) => (
        <StyledGroupButtonItem
          key={option.value}
          isPrimary={option.isPrimary}
          onClick={() => onChange(option.value)}
        >
          <Typography
            color={
              option.isPrimary ? theme.colors.white : theme.colors.darkGray
            }
            variant="h2"
          >
            {option.label}
          </Typography>
        </StyledGroupButtonItem>
      ))}
    </StyledGroupButton>
  );
};
